<template>
  <div class="col-md-12">
    <div class="row list">
      <div class="col-lg-12 col-md-12">
        <div class="card table-card shadow mb-4">
          <div class="card-header">
            <div class="form-group">
              <input type="text" class="form-control" v-model="sector" />
            </div>

            <button class="btn btn-primary" @click="getClients">
              Fetch Enrollees <i class="fe fe-users"></i>
            </button>
          </div>

          <div class="card-body">
            <strong> {{ clients.data.total }}</strong> Enrollees with Null
            Gender
            <div class="table-responsive">
              <table class="table align-td-middle table-card">
                <thead style="background: #f8fafc;">
                  <tr>
                    <th class="table-th">Name</th>
                    <th class="table-th">Sector</th>
                    <th class="table-th">LGA // Ward</th>
                    <th class="table-th">Provider Details</th>
                    <th class="table-th">LGA</th>
                    <th class="table-th">Ward</th>
                    <th class="table-th">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="client in clients.data.data"
                    v-bind:key="client.id"
                  >
                    <td>
                      <router-link
                        :to="{ path: '/client/' + client.id, params: {} }"
                      >
                        {{ client.full_name }} {{ client.agency_id }}
                      </router-link>
                    </td>

                    <!-- <td>{{ client.localgovt }}  // {{ client.ward }} </td> -->
                   
                   <td>
                    {{ client.sector }}
                   </td>
                    <td>
                      Ward: {{ client.userprovider }} //
                      <span v-if="client.userprovider != null">
                        {{ client.userprovider.agency_name }}
                      </span>
                     
                      //
                      <span v-if="client.userprovider != null">
                        {{ client.userprovider }}
                      </span>
                    </td>

                    <td>
                      <div class="form-group col-md-12">
                        <label class="info-label d-block mb-1" for="inputCity"
                          >Local Government Area<span class="text-danger"
                            >*</span
                          ></label
                        >
                        <select
                          class="form-control"
                          required
                          v-model="client.localgovt"
                          @change="fetchWards(client.localgovt)"
                        >
                          <option
                            v-for="lga in lga_states"
                            v-bind:key="lga"
                            :value="lga"
                          >
                            {{ lga.local_name }}
                          </option>
                        </select>
                      </div>
                    </td>

                    <td>
                      <div class="form-group col-md-12">
                        <label class="info-label d-block mb-1">Ward<span class="text-danger">*</span></label>
                        <select
                          class="form-control"
                          required
                          v-model="client.ward"
                          @change="changeNumber(client)"
                        >
                          <option
                            v-for="ward in wards"
                            v-bind:key="ward.id"
                            :value="ward.id"
                          >
                            {{ ward.ward_name }}
                          </option>
                        </select>
                      </div>
                    </td>

                    <!-- <td>
                      <button
                        type="button"
                        @click="changeNumber(client)"
                        class="btn btn-primary"
                        style="margin-left:10px; margin-top:10px;"
                      >
                        <i class="fe fe-edit"></i>
                      </button>
                    </td> -->
                    <!-- <td>
                      <button
                        class="btn btn-outline-danger spacer"
                        @click="deleteUser(client)"
                      >
                        <i class="fe fe-delete"></i>
                      </button>
                    </td> -->
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="vld-parent">
        <loading
          :active.sync="isLoading"
          loader="dots"
          :can-cancel="false"
          :is-full-page="fullPage"
        ></loading>
      </div>
    </div>
  </div>
</template>

<script>
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin

export default {
  components: {
    Loading,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      lga_states: true,
      states: "",
      wards: "",
      clients: "",
      sector: "Basic Healthcare Provision Fund",
    };
  },

  methods: {
    getClients() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/noCategoryofVulGrp/4`)
        .then((response) => {
          this.clients = response.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    fetchLga() {
      this.axios
        .get(`/api/v1/auth/lga/2669`)
        .then((response) => {
          this.lga_states = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    fetchWards(param) {
      this.axios
        .get(`/api/v1/auth/getwards/${param.id}`)
        .then((response) => {
          this.wards = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    assignID() {
      this.isLoading = true;
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .post(`/api/v1/auth/updateidcardnumarray/4`, {
          limiter: 200,
          sector: this.sector,
        })
        .then((response) => {
          this.$toasted.success(
            `Assigned Successfully ${response.data.remain}`,
            {
              position: "top-center",
              duration: 3000,
            }
          );
          console.log(response);
          this.isLoading = false;
        })
        .catch((error) => {
          console.error(error);
        });
    },

    changeNumber(client) {
      this.isLoading = true;
      this.axios
        .patch(`/api/v1/auth/updateCatofVulGrp/${client.id}`, {
          localgovt: client.localgovt.id,
          ward: client.ward,
        })
        .then((response) => {
          console.log(response);
          this.$toasted.success("Changed Successfully", {
            position: "top-center",
            duration: 3000,
          });
          this.isLoading = false;
        })
        .catch((error) => {
          console.error(error);
          this.$toasted.error("Error!", {
            position: "top-center",
            duration: 3000,
          });
          this.isLoading = false;
        });
    },

    deleteUser(client) {
      this.axios
        .delete(`/api/v1/auth/deleteUser/${client.id}`)
        .then((response) => {
          console.log(response);
          this.$toasted.info("Client deleted Successfully", {
            position: "top-center",
            duration: 3000,
          });
          // this.getClients();
        })
        .catch((error) => {
          this.$toasted.error("Error deleting", {
            position: "top-center",
            duration: 3000,
          });
          console.error(error);
        });
    },
  },
  created() {
    this.getClients();
    this.fetchLga();
  },
};
</script>
